import React, { Component } from "react";
import { connect } from "react-redux";

import BranchComponent from "./BranchComponent";

export class Branch extends Component {
  state = {
    tagSelected: this.props.branch !== undefined
  };

  handleValue = id => tag => {
    this.setState({ tagSelected: false });
    if (!tag || tag.length === 0) {
      return null;
    }
    this.setState({ tagSelected: true });
  };

  render() {
    const {
      id,
      lng,
      branch,
      extraClasses,
      onChange,
      onRemove,
      activateEdit,
      onClickAdd
    } = this.props;
    const { tagSelected } = this.state;

    return (
      <BranchComponent
        id={id}
        lng={lng}
        setValue={this.handleValue}
        onChange={onChange}
        onRemove={onRemove}
        tagSelected={tagSelected}
        branch={branch}
        extraClasses={extraClasses}
        activateEdit={activateEdit}
        onClickAdd={onClickAdd}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Branch);



// WEBPACK FOOTER //
// ./src/components/CategoriesList/Category/Branch/index.js